// Port/origin names come straight from the DB with inconsistent casing and,
// for some entry-point codes (e.g. "eia_eldoret", "sand_river_gate"),
// underscores instead of spaces. Normalize for display only.

// Known Kenya port-of-entry acronyms (see db/seed_entry_points.sql) that
// should stay fully uppercase instead of being Title Cased.
const ACRONYMS = new Set(["JKIA", "MIA", "EIA", "KIA", "WAP"]);

export const formatPortName = (v: string | undefined | null): string =>
  (v ?? "")
    .replace(/_/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => (ACRONYMS.has(word.toUpperCase()) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
    .join(" ");
